export default __webpack_public_path__ + "static/media/unstaking-step-three-kyl.3862acb6.svg";